import React from "react";
import { HiOutlineMoon } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneNightlife } from "../../../lib/sysNavigation/SysNavigation";

type NightlifeRow = {
  nightlife_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<NightlifeRow>
    type={_TYPES_.NIGHTLIFE}
    title="Nightlife"
    subtitle="Nightlife venues promoted on the public site."
    icon={<HiOutlineMoon className="h-5 w-5" />}
    addRoute="/data/nightlife/add"
    editRoute="/data/nightlife/edit"
    pushOne={pushOneNightlife}
    dataKey="nightlifes"
    countKey="nightlifesCount"
    idField="nightlife_id"
  />
);

export default Overview;
